import { useParams } from 'react-router-dom';
import { FarmDataContextProvider } from '../contexts/DataContext';
import { useSetFarmSourceEffect } from '../utils/hooks';
import { DesignInfoModal } from '../components/economics/DesignInfoModal';
import { DesignInfoModalProvider } from '../contexts/DesignInfoModalContext';
import { FilterContextProvider } from '../contexts/FilterContext';
import CombinedProviders from '../components/CombinedProviders';
import { NotesContextProvider } from '../contexts/NotesContext';
import { RightMenuTabContextProvider } from '../contexts/RightMenuTabContext';
import { LayoutContextProvider } from '../contexts/LayoutContext';
import FarmAuthorizationLayout from './FarmAuthorizationLayout';
import useResetFarmEffect from '../hooks/useResetFarmEffect';

const FarmLayout = () => {
  const { farmId } = useParams();
  useSetFarmSourceEffect();
  useResetFarmEffect();

  return (
    <CombinedProviders
      key={farmId}
      providers={[
        LayoutContextProvider,
        NotesContextProvider,
        RightMenuTabContextProvider,
        FilterContextProvider,
        FarmDataContextProvider,
        DesignInfoModalProvider,
      ]}
    >
      <FarmAuthorizationLayout />
      <DesignInfoModal />
    </CombinedProviders>
  );
};

export default FarmLayout;
